import { EMPLOYERS, useFetchItems } from 'pe-core-frontend';
export const useEmployers = () => {
    const { items, loading, error, refetch } = useFetchItems({
        fetchQuery: EMPLOYERS,
        dataProp: 'employers',
    });
    return { employers: items || [], loading, error, refetch };
};
